import { Link, useParams, useLocation, useNavigate } from "react-router-dom"
import { getBkendUrl, getRootUrl } from "../../consts";
import { usePdtsContext, PdtsProvider } from "../context/PdtsContext";
import { useCartContext } from "../context/CartContext";
import { randomUUID } from "../../axios_with_token";
import { useSearchContext } from "../context/SearchContext";
import { useLoginContext } from "../context/LoginContext";

const rootUrl = getRootUrl();

function Li1({catDef}){
    const { getPdtsUnderCategories, getPdtsUnderCategory } = usePdtsContext();
                
            
    const {products} = usePdtsContext();
    const pdtsInCat = products;
    const subs = [
        {
            caption: 'Featured'
        }, 
        {
            caption: 'New Arrivals'
        },
        {
            caption: 'Sale'
        }
    ];
    const suffix = randomUUID();
    // const {addItem} = useCartContext();
    return <li 
            key={catDef.caption}
            className="products-megamenu-1"><a href="#"><span>{catDef.caption}</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>

        {/* <!-- Products Mega Menu 1 Mobile View --> */}
        <ul className="mobile-megamenu">

            <li><a href="#">Featured Products</a></li>
            <li><a href="#">New Arrivals</a></li>
            <li><a href="#">Sale Items</a></li>

            <li className="dropdown"><a href="#"><span>Clothing</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                    <li><a href="#">Men's Wear</a></li>
                    <li><a href="#">Women's Wear</a></li>
                    <li><a href="#">Kids Collection</a></li>
                    <li><a href="#">Sportswear</a></li>
                    <li><a href="#">Accessories</a></li>
                </ul>
            </li>

            <li className="dropdown"><a href="#"><span>Electronics</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                    <li><a href="#">Smartphones</a></li>
                    <li><a href="#">Laptops</a></li>
                    <li><a href="#">Audio Devices</a></li>
                    <li><a href="#">Smart Home</a></li>
                    <li><a href="#">Accessories</a></li>
                </ul>
            </li>

            <li className="dropdown"><a href="#"><span>Home &amp; Living</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                    <li><a href="#">Furniture</a></li>
                    <li><a href="#">Decor</a></li>
                    <li><a href="#">Kitchen</a></li>
                    <li><a href="#">Bedding</a></li>
                    <li><a href="#">Lighting</a></li>
                </ul>
            </li>

            <li className="dropdown"><a href="#"><span>Beauty</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
            <ul>
                <li><a href="#">Skincare</a></li>
                <li><a href="#">Makeup</a></li>
                <li><a href="#">Haircare</a></li>
                <li><a href="#">Fragrances</a></li>
                <li><a href="#">Personal Care</a></li>
            </ul>
            </li>

        </ul>
        {/* <!-- End Products Mega Menu 1 Mobile View --> */}

        {/* <!-- Products Mega Menu 1 Desktop View --> */}
        <div className="desktop-megamenu">
            <div className="megamenu-tabs">
                <ul className="nav nav-tabs" id="productMegaMenuTabs" role="tablist">
                    {subs.map((subDef, subIdx)=><li
                        className="nav-item" role="presentation"
                        key={`#${subDef.caption.replace(/ /g, '-')}-${suffix}`}
                    >
                        <button
                            className={"nav-link" + (subIdx == 0? " active ": "")}
                            id={`${subDef.caption.replace(/ /g, '-')}-${suffix}-tab`}
                            data-bs-toggle="tab" role="tab" type="button"
                            data-bs-target={`#${subDef.caption.replace(/ /g, '-')}-${suffix}`}
                            aria-selected={subIdx == 0? "true": "false"}
                        >{subDef.caption}</button>
                    </li>)}
                </ul>
            </div>

            {/* <!-- Tabs Content --> */}
            <div className="megamenu-content tab-content">
                {subs.map((subDef, subIdx)=><div
                    key={`${subDef.caption.replace(/ /g, '-')}-${suffix}`}
                    className={"tab-pane fade show" + (subIdx===0?" active ":"")} role="tabpanel" 
                    id={`${subDef.caption.replace(/ /g, '-')}-${suffix}`}
                    aria-labelledby={`${subDef.caption.replace(/ /g, '-')}-${suffix}-tab`}
                >
                    <div className="product-grid">
                        {(_=>{
                            // getPdtsUnderCategories([catDef.caption]).slice(...(_=>{
                            // const a = Math.trunc(0*Math.random());
                            // return [a, a+4];
                            // })())

                            function shuffle(array) {
                                let currentIndex = array.length;

                                // While there remain elements to shuffle...
                                while (currentIndex != 0) {

                                    // Pick a remaining element...
                                    let randomIndex = Math.floor(Math.random() * currentIndex);
                                    currentIndex--;

                                    // And swap it with the current element.
                                    [array[currentIndex], array[randomIndex]] = [
                                    array[randomIndex], array[currentIndex]];
                                }
                            }                            

                            const catProducts = getPdtsUnderCategories([catDef.caption]);
                            shuffle(catProducts);
                            
                            return catProducts.slice(0, 4);
                        })().map(pdtDef=><div
                            className="product-card"
                            key={pdtDef.__id}
                        >
                            <div className="product-image">
                            <img src={pdtDef.images[0].url} alt="Featured Product" loading="lazy" />
                            </div>
                            <div className="product-info">
                            <h5>{`[${pdtDef.sn}] ${pdtDef.name}`}</h5>
                            <p className="price">${pdtDef.price}</p>
                            <Link
                                className="btn-view"
                                // onClick={evt=>window.body.blur()}
                                to={`${rootUrl}/wwapp/productDetails/${pdtDef.__id}`}
                            >View Product</Link>
                            {/* <button
                                className="btn-view"
                                onClick={evt=>addItem(pdtDef)}
                            >Add to Cart</button> */}
                            </div>
                        </div>)}
                    </div>
                </div>)}
            </div>

        </div>
        {/* <!-- End Products Mega Menu 1 Desktop View --> */}

        </li>
}

function Li2({catDef}){
    const {getPdtsUnderCategories} = usePdtsContext();
    return <li 
            className="products-megamenu-2"
    >
        <a href="#">
            <span>{catDef.caption}</span> <i className="bi bi-chevron-down toggle-dropdown"></i>
        </a>

        {/* <!-- Products Mega Menu 2 Mobile View --> */}
        <ul className="mobile-megamenu">

            {catDef.subs.map(sub=><li
                key={Math.random()}
            ><a href="#">{sub.caption}</a></li>)}

            {catDef.subs.map(sub=><li
                key={Math.random()}
                className="dropdown"
            >
                <a href="#"><span>Clothing</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                <ul>
                    <li><a href="#">Shirts &amp; Tops</a></li>
                    <li><a href="#">Coats &amp; Outerwear</a></li>
                    <li><a href="#">Underwear</a></li>
                    <li><a href="#">Sweatshirts</a></li>
                    <li><a href="#">Dresses</a></li>
                    <li><a href="#">Swimwear</a></li>
                </ul>
            </li>)}
        </ul>
        {/* <!-- End Products Mega Menu 2 Mobile View --> */}

        {/* <!-- Products Mega Menu 2 Desktop View --> */}
        <div className="desktop-megamenu">

            <div className="megamenu-tabs">
                <ul className="nav nav-tabs" role="tablist">
                    {catDef.subs.map((sub, idx)=><li 
                        key={Math.random()}
                        className="nav-item"
                        role="presentation"
                    >
                        <button
                            className={"nav-link" + (idx===0?" active ":"")}
                            id={`title-${sub.caption.replace(/ /g, '-')}`}
                            data-bs-toggle="tab"
                            data-bs-target={`#desktop-tab-${sub.caption.replace(/ /g, '-')}`}
                            type="button"
                            // aria-selected="true"
                            role="tab"
                        >{sub.caption}</button>
                    </li>)}
                </ul>
            </div>

            {/* <!-- Tabs Content --> */}
            <div className="megamenu-content tab-content">
                {catDef.subs.map((sub, idx)=><div
                    key={Math.random()}
                    className={"tab-pane fade show " + ((idx===0)?' active ':'')}
                    id={`desktop-tab-${sub.caption.replace(/ /g, '-')}`}
                    role="tabpanel"
                    aria-labelledby={`title-${sub.caption.replace(/ /g, '-')}`}
                >
                    <div className="category-layout container">
                        <div className="row">
                            <div className="col-lg-8 row">
                                {getPdtsUnderCategories([sub.caption]).slice(0,3).map(pdtDef=><div 
                                    key={pdtDef.__id}
                                    className="card col-lg-3 m-3"
                                    style={{
                                        "background":`url(${pdtDef.images[0].url}) no-repeat`,
                                        "backgroundSize":"cover",
                                        "position": "relative"
                                    }}
                                >
                                    
                                        {/* <div>
                                            <img src={pdtDef.images[0].url} className="card-img-top" alt={sub.caption} />
                                        </div> */}
                                        <div className="bg-transparent bg-white text-dark pt-3"
                                            style={{
                                                "bottom":"0",
                                                "position": "relative"
                                            }}                                        
                                        >
                                            <h6>{`[${pdtDef.sn}] ${pdtDef.name}`}</h6>
                                            <p className="price">${pdtDef.price}</p>
                                            <Link
                                                className="btn-view"
                                                // onClick={evt=>window.body.blur()}
                                                to={`${rootUrl}/wwapp/productDetails/${pdtDef.__id}`}
                                            >View Product</Link>
                                            {/* <button
                                                className="btn-view"
                                                onClick={evt=>addItem(pdtDef)}
                                            >Add to Cart</button> */}
                                        </div>

                                </div>)}
                            </div>
                            <div className="col-lg-4">

                                <div className="featured-section">
                                    <div className="featured-image">
                                    <img src={sub.images[0].url}
                                        alt={sub.caption}
                                    />
                                    <div className="featured-content">
                                        <h3>{sub.caption}</h3>
                                        <a href="#" className="btn-shop">Shop now</a>
                                    </div>
                                    </div>
                                </div>                                
                            </div>


                            {false&&getPdtsUnderCategories([sub.caption]).map(pdtDef=><div
                                className="product-card"
                                key={pdtDef.__id}
                            >
                                {/* <div className="product-image">
                                    <img src={pdtDef.images[0].url} alt="Featured Product" loading="lazy" />
                                </div> */}
                                <div className="product-info">
                                    <h5>{`[${pdtDef.sn}] ${pdtDef.name}`}</h5>
                                    <p className="price">${pdtDef.price}</p>
                                    <Link
                                        className="btn-view"
                                        // onClick={evt=>window.body.blur()}
                                        to={`${rootUrl}/wwapp/productDetails/${pdtDef.__id}`}
                                    >View Product</Link>
                                    {/* <button
                                        className="btn-view"
                                        onClick={evt=>addItem(pdtDef)}
                                    >Add to Cart</button> */}
                                </div>
                            </div>)}

                            
                            {/* <div className="category-headers">
                            <h4>Clothing</h4>
                            <h4>Shoes</h4>
                            <h4>Accessories</h4>
                            <h4>Specialty Sizes</h4>
                            </div>

                            <div className="category-links">
                            <div className="link-row">
                                <a href="#">Shirts &amp; Tops</a>
                                <a href="#">Boots</a>
                                <a href="#">Handbags</a>
                                <a href="#">Plus Size</a>
                            </div>
                            <div className="link-row">
                                <a href="#">Coats &amp; Outerwear</a>
                                <a href="#">Sandals</a>
                                <a href="#">Eyewear</a>
                                <a href="#">Petite</a>
                            </div>
                            <div className="link-row">
                                <a href="#">Underwear</a>
                                <a href="#">Heels</a>
                                <a href="#">Hats</a>
                                <a href="#">Wide Shoes</a>
                            </div>
                            <div className="link-row">
                                <a href="#">Sweatshirts</a>
                                <a href="#">Loafers</a>
                                <a href="#">Watches</a>
                                <a href="#">Narrow Shoes</a>
                            </div>
                            <div className="link-row">
                                <a href="#">Dresses</a>
                                <a href="#">Slippers</a>
                                <a href="#">Jewelry</a>
                                <a href="#"></a>
                            </div>
                            <div className="link-row">
                                <a href="#">Swimwear</a>
                                <a href="#">Oxfords</a>
                                <a href="#">Belts</a>
                                <a href="#"></a>
                            </div>
                            <div className="link-row">
                                <a href="#">View all</a>
                                <a href="#">View all</a>
                                <a href="#">View all</a>
                                <a href="#"></a>
                            </div>
                            </div> */}
                        </div>

                    </div>
                </div>)}
            </div>

        </div>
        {/* <!-- End Products Mega Menu 2 Desktop View --> */}

    </li>;

}

function LCat({catDef}){
    if(catDef.subs){
        return <Li2 key={catDef.caption} cat={catDef.caption} catDef={catDef}></Li2>
    }else{
        return <Li1 key={catDef.caption} cat={catDef.caption} catDef={catDef}></Li1>
    }
}

function PdtCategories(){
    const {pdtCategories} = usePdtsContext();
    return <>
        {
            pdtCategories.map(cat=><LCat
                key={Math.random()}
                catDef={cat}
            ></LCat>)
        }
    </>
}

function Search(){
    const {searchStr, setSearchStr} = useSearchContext();
    const { category, setCategory } = usePdtsContext();
    const navigate = useNavigate();
    
    return <form className="search-form desktop-search-form"
            onSubmit={evt=>{
                // evt.stopPropagation();
                evt.preventDefault();
                const { elements } = evt.target;   // same as `form.elements`
                const searchStr = elements.searchStr.value; // `name` attribute → property
                setCategory([]);
                setSearchStr(searchStr);
                // elements.searchStr.value = '';
                navigate(`${rootUrl}/wwapp/category`);
            }}            
    >
        <div className="input-group">
        <input name="searchStr" type="text" className="form-control" placeholder="Search for products" />
        <button className="btn" type="submit">
            <i className="bi bi-search"></i>
        </button>
        </div>
    </form>;
}

export default function Header(){
    const { pathname } = useLocation();
    const cleanPath = pathname.split(/[?#]/)[0];
    const parts = cleanPath.split('/').filter(Boolean);
    const page = parts.length ? parts[parts.length - 1] : null;

    const {totalItems, wishList} = useCartContext();


    const {loggedIn, userInfo:wwAppUserInfo, logout} = useLoginContext();

    return <PdtsProvider><header id="header" className="header fixed-top sticky-top ">
        {/* <!-- Top Bar --> */}
        <div className="top-bar py-2">
        <div className="container-fluid container-xl">
            <div className="row align-items-center">
            <div className="col-lg-4 d-none d-lg-flex">
                <div className="top-bar-item">
                    <i className="bi bi-telephone-fill me-2"></i>
                    <span>Need help? Call us: </span>
                    <a href="tel:+16043701181">+1 (604) 370 1181</a>
                </div>
            </div>

            <div className="col-lg-4 col-md-12 text-center">
                <div className="announcement-slider swiper init-swiper">
                {/* <script type="application/json" className="swiper-config">
                    {
                    "loop": true,
                    "speed": 600,
                    "autoplay": {
                        "delay": 5000
                    },
                    "slidesPerView": 1,
                    "direction": "vertical",
                    "effect": "slide"
                    }
                </script> */}
                <div className="swiper-wrapper">
                    {/* <div className="swiper-slide">🚚 Free shipping on orders over $5000</div> */}
                    {/* <div className="swiper-slide">💰 30 days money back guarantee.</div>
                    <div className="swiper-slide">🎁 20% off on your first order</div> */}
                </div>
                </div>
            </div>

            <div className="col-lg-4 d-none d-lg-block">
                <div className="d-flex justify-content-end">
                    <div className="top-bar-item dropdown me-3">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                            <i className="bi bi-translate me-2"></i>EN
                        </a>
                        <ul className="dropdown-menu">
                        <li><a className="dropdown-item" href="#"><i className="bi bi-check2 me-2 selected-icon"></i>English</a></li>
                        <li><a className="dropdown-item" href="#">Français</a></li>
                        </ul>
                    </div>
                    <div className="top-bar-item dropdown">
                        <a href="#" className="dropdown-toggle" data-bs-toggle="dropdown">
                        <i className="bi bi-currency-dollar me-2"></i>CAD
                        </a>
                        <ul className="dropdown-menu">
                            <li><a className="dropdown-item" href="#"><i className="bi bi-check2 me-2 selected-icon"></i>CAD</a></li>
                            <li><a className="dropdown-item" href="#"><i className="bi bi-check2 me-2 selected-icon"></i>USD</a></li>
                        </ul>
                    </div>
                </div>
            </div>
            </div>
        </div>
        </div>

        {/* <!-- Main Header --> */}
        <div className="main-header">
        <div className="container-fluid container-xl">
            <div className="d-flex py-3 align-items-center justify-content-between">

            {/* <!-- Logo --> */}
            <a href="index.html" className="logo d-flex align-items-center">
                {/* <!-- Uncomment the line below if you also wish to use an image logo --> */}
                {/* <!-- <img src="assets/niceshop/img/logo.webp" alt=""> --> */}
                <h1 className="sitename">Willowest online order</h1>
            </a>

            {/* <!-- Search --> */}
            <Search></Search>

            {/* <!-- Actions --> */}
            <div className="header-actions d-flex align-items-center justify-content-end">

                {/* <!-- Mobile Search Toggle --> */}
                <button className="header-action-btn mobile-search-toggle d-xl-none" type="button" data-bs-toggle="collapse" data-bs-target="#mobileSearch" aria-expanded="false" aria-controls="mobileSearch">
                <i className="bi bi-search"></i>
                </button>

                {/* <!-- Account --> */}
                <div className="dropdown account-dropdown">
                <button className="header-action-btn" data-bs-toggle="dropdown">
                    <i className="bi bi-person"></i>
                    {/* <span className="align-text-top align-top"> guest </span> */}
                </button>
                <div className="dropdown-menu">
                    <div className="dropdown-header">
                    <h5>{wwAppUserInfo.email}</h5>
                    {/* <h5>[{JSON.stringify(userInfo)}]</h5> */}
                    {/* <h6>Welcome to <span className="sitename">Willowest</span></h6> */}
                    <p className="mb-0">Access account &amp; manage orders</p>
                    </div>
                    <div className="dropdown-body">
                    <Link
                        className="dropdown-item d-flex align-items-center"
                        to={`${rootUrl}/wwapp/account`}
                    >
                        <i className="bi bi-person-circle me-2"></i>
                        <span>My Profile</span>                    
                    </Link>
                    <a className="dropdown-item d-flex align-items-center" href="account.html">
                        <i className="bi bi-bag-check me-2"></i>
                        <span>My Orders</span>
                    </a>
                    <a className="dropdown-item d-flex align-items-center" href="account.html">
                        <i className="bi bi-heart me-2"></i>
                        <span>My Wishlist</span>
                    </a>

                    
                    <a className="dropdown-item d-flex align-items-center" href="account.html">
                        <i className="bi bi-gear me-2"></i>
                        <span>Settings</span>
                    </a>
                    
                    {(wwAppUserInfo.userType=='clientGroup')&&<Link 
                        to={`${rootUrl}/wwapp/subsidaries`}
                        className="dropdown-item d-flex align-items-center" href="account.html"
                    >
                        <i className="bi bi-diagram-3 me-2"></i>
                        <span>Subsidaries</span>
                    </Link>}

                    </div>
                    <div className="dropdown-footer">
                        {/* {!loggedIn&&<Link
                            className="btn btn-primary w-100 mb-2"
                            to={`${rootUrl}/wwapp/login`}
                        >Sign In</Link>}
                        {!loggedIn&&<Link
                            className="btn btn-outline-primary w-100"
                            to={`${rootUrl}/wwapp/register`}
                        >Register</Link>} */}
                        <button
                            type="button"
                            className="btn btn-outline-primary w-100"
                            onClick={evt=>logout()}
                        >Log out</button>
                    </div>
                </div>
                </div>

                {/* <!-- Wishlist --> */}
                <a href="account.html" className="header-action-btn d-none d-md-block">
                <i className="bi bi-heart"></i>
                <span className={"badge" + (wishList.length>0?" bg-danger":"")}>{wishList.length}</span>
                </a>

                {/* <!-- Cart --> */}
                <Link
                    className="header-action-btn"
                    to={`${rootUrl}/wwapp/cart`}
                >
                    <i className="bi bi-cart3"></i>
                    <span className={"badge" + (totalItems>0?" bg-danger":"")}>{totalItems}</span>
                </Link>

                {/* <!-- Mobile Navigation Toggle --> */}
                <i className="mobile-nav-toggle d-xl-none bi bi-list me-0"></i>

            </div>
            </div>
        </div>
        </div>

        {/* <!-- Navigation --> */}
        <div className="header-nav">
            <div className="container-fluid container-xl position-relative">
                <div className="row ">
                    <nav id="navmenu" className="navmenu col-lg-6 z-1">
                        <ul>
                            {/* <li>
                                <Link 
                                    to={`${rootUrl}/wwapp`}
                                    className={page=='wwapp'?"active":''}
                                >Home</Link>
                            </li> */}
                            {/* <li>
                                <Link
                                    to={`${rootUrl}/wwapp/about`}
                                    className={page=='about'?"active":''}
                                >About</Link>
                            </li> */}
{/* 
                            <li>
                                <Link
                                    to={`${rootUrl}/wwapp/contact`}
                                    className={page=='contact'?"active":''}
                                >Contact</Link>
                            </li> */}

                            {/* <li>
                                <Link
                                    to={`${rootUrl}/wwapp/category`}
                                    className={page=='category'?"active":''}
                                >Category</Link>
                            </li> */}
                            {/* <li>
                                <Link
                                    to={`${rootUrl}/wwapp/productdetails`}
                                    className={page=='productdetails'?"active":''}
                                >Product Details</Link>
                            </li> */}
                            {/* <li>
                                <Link
                                    to={`${rootUrl}/wwapp/cart`}
                                    className={page=='cart'?"active":''}
                                >Cart</Link>
                            </li> */}

                            {/* <li>
                                <Link
                                    to={`${rootUrl}/wwapp/checkout`}
                                    className={page=='checkout'?"active":''}
                                >Checkout</Link>
                            </li> */}

                            <li>
                                <Link
                                    to={`${rootUrl}/wwapp/category`}
                                    className={page=='category'?"active":''}
                                >All Products</Link>
                            </li>

                            {/* <li className="dropdown"><a href="#"><span>Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                            <ul>
                                <li><a href="#">Dropdown 1</a></li>
                                <li className="dropdown"><a href="#"><span>Deep Dropdown</span> <i className="bi bi-chevron-down toggle-dropdown"></i></a>
                                <ul>
                                    <li><a href="#">Deep Dropdown 1</a></li>
                                    <li><a href="#">Deep Dropdown 2</a></li>
                                    <li><a href="#">Deep Dropdown 3</a></li>
                                    <li><a href="#">Deep Dropdown 4</a></li>
                                    <li><a href="#">Deep Dropdown 5</a></li>
                                </ul>
                                </li>
                                <li><a href="#">Dropdown 2</a></li>
                                <li><a href="#">Dropdown 3</a></li>
                                <li><a href="#">Dropdown 4</a></li>
                            </ul>
                            </li> */}
                            <PdtCategories></PdtCategories>
                        </ul>
                    </nav>
                    <nav id="navmenu" className="navmenu col-lg-6 d-flex justify-content-end z-0">
                        <ul>
                            <li>
                                {/* <a href="contact.html">Contact</a> */}
                                <Link
                                    to={`${rootUrl}/wwapp/contact`}
                                    className={page=='contact'?"active":''}
                                >Contact</Link>
                            </li>
                            <li>
                                {/* <a href="cart.html">Cart</a> */}
                                <Link
                                    to={`${rootUrl}/wwapp/cart`}
                                    className={page=='cart'?"active":''}
                                >Cart</Link>
                            </li>
                        </ul>
                    </nav>

                </div>
            </div>
        </div>

        {/* <!-- Mobile Search Form --> */}
        <div className="collapse" id="mobileSearch">
        <div className="container">
            <form className="search-form">
            <div className="input-group">
                <input type="text" className="form-control" placeholder="Search for products" />
                <button className="btn" type="submit">
                <i className="bi bi-search"></i>
                </button>
            </div>
            </form>
        </div>
        </div>
    </header>
    {/* <div style={{"height":"12em"}}></div> */}
    
    </PdtsProvider>
}